export default "__VITE_ASSET__CgGqMQCX__"